/* =========================================================
   Debellin Cart Drawer — rekomendasi "Lengkapi dapurmu"
   dan dropdown "Jadikan hadiah" (gift wrap + pesan kartu, grafir nama, gift card).
   Bekerja bersama cart.js & cart-drawer.js bawaan Dawn.
   ========================================================= */
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const recsCache = new Map();

  const formatIDR = (cents) =>
    'Rp ' + Math.round(cents / 100).toLocaleString('id-ID');

  const stripHtml = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const escapeHtml = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  async function fetchRecs(productId) {
    if (recsCache.has(productId)) return recsCache.get(productId);
    const load = async (intent) => {
      const res = await fetch(`${root}recommendations/products.json?product_id=${productId}&limit=8&intent=${intent}`);
      if (!res.ok) return [];
      const data = await res.json();
      return data.products || [];
    };
    const promise = (async () => {
      let products = await load('complementary');
      if (!products.length) products = await load('related');
      return products;
    })();
    recsCache.set(productId, promise);
    return promise;
  }

  function imageUrl(src, width) {
    if (!src) return '';
    const url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  }

  class DcCartRecs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dc-recs__track');
      this.prev = this.querySelector('.dc-recs__nav--prev');
      this.next = this.querySelector('.dc-recs__nav--next');
      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateNav(), { passive: true });
      this.render();
    }

    async render() {
      const productId = this.dataset.productId;
      if (!productId) return;
      const inCart = new Set((this.dataset.inCart || '').split(',').filter(Boolean).map(Number));
      const promoTag = (this.dataset.promoTag || 'promo').toLowerCase();
      const memberTag = (this.dataset.memberTag || '7%').toLowerCase();
      const excludeHandles = (this.dataset.excludeHandle || '').split(',').filter(Boolean);

      let products = [];
      try {
        products = await fetchRecs(productId);
      } catch (e) {
        return;
      }
      products = products
        .filter((p) => p.available && !inCart.has(p.id) && !excludeHandles.includes(p.handle))
        .slice(0, 6);
      if (!products.length || !this.isConnected) return;

      this.track.innerHTML = products.map((p) => this.cardHtml(p, promoTag, memberTag)).join('');
      this.track.querySelectorAll('.dc-rec').forEach((card) => this.bindCard(card));
      this.hidden = false;
      this.updateNav();
    }

    cardHtml(p, promoTag, memberTag) {
      const variants = p.variants.filter((v) => v.available);
      const first = variants[0];
      const tags = (p.tags || []).map((t) => String(t).toLowerCase().trim());
      const isPromo = tags.includes(promoTag);
      const isMember = tags.includes(memberTag);
      const hasCompare = first.compare_at_price && first.compare_at_price > first.price;
      const comparePct = hasCompare ? Math.floor(((first.compare_at_price - first.price) * 100) / first.compare_at_price) : 0;
      const variantSelect =
        variants.length > 1
          ? `<select class="dc-rec__variant" aria-label="Pilih varian ${escapeHtml(p.title)}">${variants
              .map(
                (v) =>
                  `<option value="${v.id}" data-price="${v.price}" data-compare="${v.compare_at_price || 0}">${escapeHtml(v.title)}</option>`
              )
              .join('')}</select>`
          : '';

      return `
        <article class="dc-rec" data-variant-id="${first.id}">
          <img class="dc-rec__img" src="${imageUrl(p.featured_image, 240)}" alt="${escapeHtml(p.title)}" loading="lazy" width="88" height="88">
          <div>
            <div class="dc-item__badges">
              ${isPromo ? '<span class="dc-badge dc-badge--promo">Promo</span>' : ''}
              ${comparePct > 0 ? `<span class="dc-badge dc-badge--discount">Discount ${comparePct}%</span>` : ''}
              ${isMember ? '<span class="dc-badge dc-badge--member">7% OFF</span>' : ''}
            </div>
            <div class="dc-rec__head">
              <h4 class="dc-rec__name"><a href="${p.url}" class="link link--text">${escapeHtml(p.title)}</a></h4>
              <span class="dc-rec__price">${hasCompare ? `<s>${formatIDR(first.compare_at_price)}</s>` : ''}<span data-price>${formatIDR(first.price)}</span></span>
            </div>
            <p class="dc-rec__desc">${escapeHtml(stripHtml(p.description).slice(0, 160))}</p>
          </div>
          <div class="dc-rec__actions">
            ${variantSelect}
            <button type="button" class="button dc-rec__add">Tambah ke Keranjang</button>
          </div>
        </article>`;
    }

    bindCard(card) {
      const select = card.querySelector('.dc-rec__variant');
      const priceEl = card.querySelector('.dc-rec__price');
      if (select) {
        select.addEventListener('change', () => {
          const opt = select.selectedOptions[0];
          card.dataset.variantId = opt.value;
          const price = Number(opt.dataset.price);
          const compare = Number(opt.dataset.compare);
          priceEl.innerHTML = (compare > price ? `<s>${formatIDR(compare)}</s>` : '') + `<span data-price>${formatIDR(price)}</span>`;
        });
      }
      card.querySelector('.dc-rec__add').addEventListener('click', (e) => this.addToCart(card, e.currentTarget));
    }

    async addToCart(card, button) {
      const cartDrawer = document.querySelector('cart-drawer');
      button.setAttribute('aria-busy', 'true');
      const label = button.textContent;
      button.textContent = 'Menambahkan…';
      try {
        const sections = cartDrawer && cartDrawer.getSectionsToRender
          ? cartDrawer.getSectionsToRender().map((s) => s.id)
          : ['cart-drawer', 'cart-icon-bubble'];
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(card.dataset.variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.renderContents({ id: Number(card.dataset.variantId), sections: data.sections });
        } else {
          window.location.href = `${root}cart`;
        }
      } catch (err) {
        button.textContent = 'Gagal, coba lagi';
        setTimeout(() => {
          if (button.isConnected) {
            button.textContent = label;
            button.removeAttribute('aria-busy');
          }
        }, 2000);
      }
    }

    scrollByCard(dir) {
      this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
    }

    updateNav() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }

  if (!customElements.get('dc-cart-recs')) customElements.define('dc-cart-recs', DcCartRecs);

  // Dawn hanya me-refresh daftar item & footer saat cartUpdate dari sumber lain
  // (app upsell, quick add, dll). Sinkronkan juga progress ongkir & jumlah item.
  function syncShippingBar() {
    fetch(`${root}cart?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        const newShip = doc.querySelector('.dc-ship');
        const oldShip = drawer.querySelector('.dc-ship');
        if (oldShip && newShip) oldShip.replaceWith(newShip);
        else if (oldShip) oldShip.remove();
        else if (newShip) drawer.querySelector('.dc-header')?.after(newShip);
        const newGift = doc.querySelector('dc-gift-options');
        const oldGift = drawer.querySelector('dc-gift-options');
        if (newGift && oldGift) oldGift.replaceWith(newGift);
        const newCount = doc.querySelector('.dc-header__count');
        const oldCount = drawer.querySelector('.dc-header__count');
        if (newCount && oldCount) oldCount.replaceWith(newCount);
      })
      .catch(() => {});
  }
  function hookPubSub() {
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event || event.source !== 'cart-items') syncShippingBar();
      });
      return true;
    }
    return false;
  }
  if (!hookPubSub()) document.addEventListener('DOMContentLoaded', hookPubSub, { once: true });

  // Dropdown "Jadikan hadiah". Tiap pilihan (dc-addon) = satu produk add-on:
  // centang -> produk masuk cart (qty 1) + atribut pesanan "<flag>: Ya";
  // isian (pesan kartu / nama grafir) disimpan sebagai atribut pesanan dan
  // properti baris produk add-on. Lepas centang -> produk & atribut dihapus.
  let giftOpen = false;

  function sectionsToRender() {
    const drawer = document.querySelector('cart-drawer');
    return drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];
  }

  async function postCart(endpoint, payload) {
    const res = await fetch(`${root}cart/${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message);
    return data;
  }

  function rerender(data) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents && data.sections) {
      drawer.renderContents({ id: null, sections: data.sections });
    } else {
      window.location.reload();
    }
  }

  class DcGiftOptions extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;
      if (giftOpen) this.details.open = true;
      this.details.addEventListener('toggle', () => {
        giftOpen = this.details.open;
      });
    }
  }

  class DcAddon extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.dc-addon__check');
      this.input = this.querySelector('.dc-addon__input');
      this.status = this.querySelector('.dc-gift__msg-status');
      this.count = this.querySelector('[data-count]');
      this.saved = this.input ? this.input.value.trim() : '';

      this.checkbox.addEventListener('change', () => this.toggle(this.checkbox.checked));
      this.querySelectorAll('.dc-addon__variant').forEach((btn) =>
        btn.addEventListener('click', () => this.pickVariant(btn))
      );
      if (this.input) {
        this.input.addEventListener('input', () => {
          if (this.count) this.count.textContent = this.input.value.length;
          this.classList.remove('has-error');
          this.setStatus('');
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.save(), 900);
        });
        this.input.addEventListener('change', () => {
          clearTimeout(this.timer);
          this.save();
        });
      }

      // Produk add-on dihapus lewat tombol hapus: bersihkan atribut yang tertinggal
      if (this.dataset.stale === 'true') {
        postCart('update.js', { attributes: this.clearAttrs() }).catch(() => {});
      }
    }

    clearAttrs() {
      const attrs = { [this.dataset.flag]: '' };
      if (this.dataset.prop) attrs[this.dataset.prop] = '';
      return attrs;
    }

    // Pilih nominal/varian. Belum dicentang: cukup ganti pilihan.
    // Sudah dicentang: ganti varian di cart (lama 0, baru 1).
    async pickVariant(btn) {
      const newId = Number(btn.dataset.variantId);
      const oldId = Number(this.dataset.variantId);
      if (newId === oldId) return;
      const setActive = (id) => {
        this.querySelectorAll('.dc-addon__variant').forEach((b) => {
          const on = Number(b.dataset.variantId) === id;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) {
            const price = this.querySelector('[data-addon-price]');
            if (price) price.textContent = b.dataset.price;
          }
        });
        this.dataset.variantId = id;
      };
      setActive(newId);
      if (!this.isOn) return;
      const group = this.closest('dc-gift-options');
      if (group) group.classList.add('is-busy');
      this.querySelectorAll('.dc-addon__variant').forEach((b) => (b.disabled = true));
      giftOpen = true;
      try {
        const data = await postCart('update.js', {
          updates: { [oldId]: 0, [newId]: 1 },
          sections: sectionsToRender(),
          sections_url: window.location.pathname,
        });
        rerender(data);
      } catch (e) {
        setActive(oldId);
        this.querySelectorAll('.dc-addon__variant').forEach((b) => (b.disabled = false));
        if (group) group.classList.remove('is-busy');
      }
    }

    get isOn() {
      return this.classList.contains('is-on');
    }

    get isDirty() {
      return !!this.input && this.input.value.trim() !== this.saved;
    }

    get isMissing() {
      return this.dataset.required === 'true' && this.isOn && !!this.input && !this.input.value.trim();
    }

    setStatus(text) {
      if (this.status) this.status.textContent = text;
    }

    async toggle(on) {
      const group = this.closest('dc-gift-options');
      if (group) group.classList.add('is-busy');
      this.checkbox.disabled = true;
      giftOpen = true;
      try {
        const variantId = Number(this.dataset.variantId);
        const data = await postCart('update.js', {
          updates: { [variantId]: on ? 1 : 0 },
          attributes: on
            ? { [this.dataset.flag]: 'Ya' }
            : this.clearAttrs(),
          sections: sectionsToRender(),
          sections_url: window.location.pathname,
        });
        rerender(data);
        if (on) {
          setTimeout(() => {
            document
              .querySelector(`dc-addon[data-variant-id="${variantId}"] .dc-addon__input`)
              ?.focus();
          }, 350);
        }
      } catch (e) {
        this.checkbox.checked = !on;
        this.checkbox.disabled = false;
        if (group) group.classList.remove('is-busy');
        alert('Maaf, pilihan ini belum bisa ditambahkan. Coba lagi ya.');
      }
    }

    async save() {
      if (!this.input || !this.isDirty) return;
      const text = this.input.value.trim();
      const prop = this.dataset.prop;
      this.setStatus('Menyimpan…');
      try {
        await postCart('update.js', { attributes: { [prop]: text } });
        const key = this.dataset.lineKey;
        if (key) {
          const data = await postCart('change.js', {
            id: key,
            quantity: 1,
            properties: text ? { [prop]: text } : {},
          });
          const line = (data.items || []).find((i) => i.variant_id === Number(this.dataset.variantId));
          if (line) this.dataset.lineKey = line.key;
        }
        this.saved = text;
        this.setStatus('Tersimpan ✓');
      } catch (e) {
        this.setStatus('Gagal menyimpan, coba lagi');
      }
    }
  }

  if (!customElements.get('dc-gift-options')) customElements.define('dc-gift-options', DcGiftOptions);
  if (!customElements.get('dc-addon')) customElements.define('dc-addon', DcAddon);

  // Sebelum checkout: nama grafir wajib diisi, dan isian yang belum tersimpan disimpan dulu
  document.addEventListener(
    'click',
    async (event) => {
      const btn = event.target.closest && event.target.closest('#CartDrawer-Checkout');
      if (!btn) return;
      const addons = [...document.querySelectorAll('cart-drawer dc-addon.is-on')];
      const missing = addons.find((a) => a.isMissing);
      const dirty = addons.filter((a) => a.isDirty);
      if (!missing && !dirty.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (missing) {
        const details = missing.closest('details');
        if (details) details.open = true;
        giftOpen = true;
        missing.classList.add('has-error');
        missing.setStatus('Wajib diisi sebelum checkout');
        missing.input.focus();
        return;
      }
      btn.setAttribute('aria-disabled', 'true');
      await Promise.all(dirty.map((a) => a.save()));
      window.location.href = `${root}checkout`;
    },
    true
  );
})();
